export default __webpack_public_path__ + "static/media/gold_ring.aa7785d4.png";